module.exports = __webpack_public_path__ + "static/media/Wrestling Champion.feea8b62.jpg";